<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <strong>
          <span class="text-danger">*</span>
          중요하거나 예외로 처리해야 하는 관리자 액세스 IP, API IP 등을 설정해요.
        </strong>
        <br><br>
        <strong>
          <span class="text-danger">*</span>
          예시 : 한 행에 하나의 IP 주소를 작성 해주세요.
        </strong>
        <br>
        111.222.111.222
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col :sm="is_setup ? '12' : '6'">
        <strong>허용 IP : <span class="text-danger">정책에 적용되지 않는 아이피</span></strong> (<span class="text-danger">*</span> 모든 정책 예외)
        <b-button class="pull-right" size="sm" variant="outline-info" @click="explain_ip_allow = true"><i class="fa fa-question"></i></b-button>
        <br><br>
        <b-form-group>
          <b-form-textarea @update="allow_ip($event, 'allow_ip')" @change="allow_ip" v-model="model.allow_ip" :row="10" :max-rows="50" :disabled="ip_lock"></b-form-textarea>
        </b-form-group>
      </b-col>
      <!-- is_setup 사용, 아직 블럭할 ip 를 구분할 수 없을 것임 -->
      <b-col sm="6" v-if="!is_setup">
        <strong>
          <!-- <b-badge v-if="server.mode == 'DetectionOnly' || server.mode == 1" variant="warning">Detection</b-badge>
          <b-badge v-else-if="server.mode == 'On' || server.mode == 2" variant="danger">Block</b-badge>
          <span v-else>-</span> -->
          차단 IP : <span class="text-danger">방화벽 모드에 상관없이 차단</span>
        </strong>
        <b-button class="pull-right" size="sm" variant="outline-info" @click="explain_ip_block_or_detect = true"><i class="fa fa-question"></i></b-button>
        <br><br>
        <b-form-group>
          <b-form-textarea @update="block_ip($event, 'block_ip')" @change="block_ip" v-model="model.block_ip" :row="10" :max-rows="50" :disabled="ip_lock"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="허용 IP"  class="modal-info" v-model="explain_ip_allow" ok-variant="outline-primary" ok-title="확인" header-bg-variant="add" ok-only>
      <p>특정 아이피 주소 혹은 범위를 허용할 수 있어요</p>
      <p>ex ) 211.222.235.14</p>
    </b-modal>
    <b-modal title="IP 주소 관리"  class="modal-info" v-model="explain_ip_block_or_detect" ok-variant="outline-warning" ok-title="확인" header-bg-variant="warning" ok-only>
      <p>특정 아이피 주소 혹은 범위를 차단할 수 있어요</p>
      <p>ex ) 211.222.235.14</p>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
